import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const isForYou = ['Quieres soluciones naturales y respaldadas por ciencia.', 'Eres una mujer ocupada y necesitas estrategias prácticas.', 'Estás lista para hacer cambios pequeños pero poderosos.'];
const notForYou = ['Buscas pastillas milagrosas o atajos irreales.', 'No estás dispuesta a ajustar tus hábitos básicos.', 'Esperas resultados de la noche a la mañana sin esfuerzo.'];
export function ForYouSection() {
  return <section className="py-20 md:py-32 bg-cream" data-id="element-71">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20" data-id="element-73">
          {/* Es para ti si... */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-sage-50/50 p-8 md:p-10 rounded-3xl border border-sage-100" data-id="element-74">
            <h3 className="text-3xl font-bold mb-8 text-sage-800" data-id="element-75">
              Es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-76">
              {isForYou.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-77">
                  <CheckCircle2 className="text-sage-600 flex-shrink-0 mt-1" size={24} data-id="element-78" />
                  <span className="text-lg text-charcoal-light leading-relaxed" data-id="element-79">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti si... */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="p-8 md:p-10 rounded-3xl border border-gray-200 bg-white/50" data-id="element-80">
            <h3 className="text-3xl font-bold mb-8 text-gray-500" data-id="element-81">
              No es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-82">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-4 opacity-75" data-id="element-83">
                  <XCircle className="text-gray-400 flex-shrink-0 mt-1" size={24} data-id="element-84" />
                  <span className="text-lg text-gray-600 leading-relaxed" data-id="element-85">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}